<template>
  <card-item legend="Estatística de Acesso" icon="user-friends" icon-type="fa">
    <template v-slot:card-icon>
      <svg style="width: 24px; height: 24px" fill="currentColor" fill-rule="evenodd" height="100%" viewBox="0 0 24 24"
           width="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
        <path d="M12 14h10v-4H12zm0 8v-4h10v4z" opacity=".8"></path>
        <path d="M2 14h10v-4H2zm7 8h3v-4H9zM2 6h7V2H2z"></path>
      </svg>
    </template>
    <div class="card-content min-pad">
      <div style="width: 100%" id="container-chart-acesso-stats"></div>
    </div>
    <div class="diviser"></div>
    <a class="card-btn">
      <u-icon name="arrow_forward"/>
      Acessar monitoramento
    </a>
  </card-item>
</template>

<script>
import CardItem from '@/reuse/card/Card'
import Highcharts from 'highcharts'
// import {date} from 'uloc-vue'
import Mixin from './mixin'

const mock = {
  'identificados': [],
  'anonimos': []
}

export default {
  name: "AcessoStats",
  mixins: [Mixin],
  components: {CardItem},
  data() {
    return {
      identificados: null,
      anonimos: null,
      intervalo: []
    }
  },
  mounted() {
    this.gerarGrafico()
  },
  computed: {
    acessos() {
      if (!this.basicData || !this.basicData.acessosSite) {
        return mock
      }
      return this.basicData.acessosSite
    }
  },
  watch: {
    acessos (v) {
      this.identificados = this.acessos.identificados.map(v => v[1])
      this.anonimos = this.acessos.anonimos.map(v => v[1])
      this.intervalo = this.acessos.identificados.map(v => {
        return this.$options.filters.formatDate( v[0], 'HH:mm')
      })
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.series[0].setData(this.identificados)
          this.chart.series[1].setData(this.anonimos)
          this.chart.xAxis[0].categories = this.intervalo;
          this.chart.xAxis[0].setCategories(this.intervalo)
          this.chart.redraw()
        }
      })
    }
  },
  methods: {
    gerarGrafico() {
      this.$nextTick(() => {
        this.identificados = this.acessos.identificados.map(v => v[1])
        this.anonimos = this.acessos.anonimos.map(v => v[1])

        Highcharts.setOptions({
          lang: {
            thousandsSep: '.'
          }
        })

        this.chart = new Highcharts.chart('container-chart-acesso-stats', {

          chart: {
            height: 300
          },
          title: {
            text: null
          },

          yAxis: {
            title: {
              text: null
            },
            min: 0,
            minRange: 10
          },

          xAxis: {
            accessibility: {
              // rangeDescription: 'Range: 2010 to 2017'
            },
            categories: this.intervalo
          },


          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },

          plotOptions: {
            line: {
              dataLabels: {
                enabled: true
              },
              enableMouseTracking: false
            }
          },

          series: [
            {
              name: 'Identificados',
              data: this.identificados
            },
            {
              name: 'Anônimos',
              data: this.anonimos
            }
          ],

          responsive: {
            rules: [{
              condition: {},
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }]
          }

        })
      })
    }
  }
}
</script>
